import { useState } from 'react';

/**
 * A react hook for accessing localStorage.
 * Like useState, but the first arg is the key to the value in localStorage,
 * the second arg is the initial value, default is undefined.
 * i.e.
 *   const [token, setToken] = useLocalStorage('token', 'eyJraWQIi...');
 * or
 *   const [token, setToken] = useLocalStorage('token');
 *
 */
function useLocalStorage(key, initialValue) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return initialValue;
        }
    });

    const setValue = value => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    return [storedValue, setValue];
}

export default useLocalStorage;
